import styled from 'styled-components';

export const Content = styled.span`
  svg {
    fill: ${(props) => (props.theme.theme === 'dark' ? '#b7babf' : '#000')};
  }
`;
